import { render, staticRenderFns } from "./mainContacts.vue?vue&type=template&id=03569f2e&lang=pug"
import script from "./mainContacts.vue?vue&type=script&lang=js"
export * from "./mainContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports